import React from 'react';
import {
  addPathToList,
  description_upload, empty_state_paragraph, empty_state_title, Upload_assets,
} from '../utils/DictionaryManagementUtils';
import FullPagePanel from '../components/PanelsComponents/General/FullPagePanel';
import UploadMenu from '../components/PanelsComponents/Upload/UploadMenu';
import BreakLine from '../components/PanelsComponents/General/BreakLine';

//= ========================================================================
const Panel_T03_launch_error_messages = ({
  globJSON,
  selectedScreen,
  onConfigChanged,
  onStepPressed,
  language,
}) => {
  const editTextList = [
    'your_bills',
    'nothing_to_see_here',
  ];
  const listObject = [
    {
      subHeadline: empty_state_title,
      fileId: 'configurations/launch/empty_state/empty_state_icon',
    },
  ];

  return (
    <FullPagePanel
      globJSON={globJSON}
      onConfigChanged={onConfigChanged}
      selectedScreen={selectedScreen}
      onStepPressed={onStepPressed}
      panelHeadline={empty_state_title}
      editTextList={addPathToList(editTextList, 'configurations/launch/empty_state/')}
      tooltipsTitles={globJSON.configurations.launch.screens_ordering}
      paragraph={empty_state_paragraph}
      isHollow
      language={language}
      paddingVertical={25}
    >
      <BreakLine />
      <UploadMenu
        globJSON={globJSON}
        onConfigChanged={onConfigChanged}
        headline={Upload_assets}
        details={description_upload}
        listObject={listObject}
      />
    </FullPagePanel>
  );
};

export default Panel_T03_launch_error_messages;
